
export class PerfisServicosModel  {

    public idPerfil: string;
    public descPerfil: string;
    public tipoPerfil: string;
    public tipoRestricao: string; 
    public tipoNovoRestricao: string; 
    public inscricaoAprovacao: string;
    public grupos:Grupo[] = [];
    public isValido: boolean;

    static isRestrito(perfil: PerfisServicosModel): boolean {
      return '2' == perfil.tipoPerfil && '1' == perfil.tipoRestricao;
    }
}

export  class Grupo {
  //  public idGrupo: number;
    public siglaGrupo: string;
    public descGrupo: string;
    public servicos: Servico[] = [];
 }

 export  class Servico {
   public idServico: string;
   public descServico: string;
}